import { Link } from "react-router-dom"

const navigation = {
    support: [
        { name: 'Pricing Plans', href: '#' },
        { name: 'Become a Partner ', href: '#' },
        { name: 'Our Impact Fund', href: '#' },
        { name: 'Privacy Policy', href: '/privacy-policy' },
        { name: 'Terms and Conditions', href: '/terms-conditions' },
    ],
    about: [
        { name: 'About Us', href: '/about' },
        { name: 'Contact us', href: '/contact' },
    ],
    social: [
        {
            name: 'Linkedin',
            href: '#',
            icon: '/linkedin.svg',
        },
        // {
        //     name: 'Youtube',
        //     href: '#',
        //     icon: '/youtube.svg',
        // },
        // {
        //     name: 'Twitter',
        //     href: '#',
        //     icon: '/twitter.svg',
        // },
        // {
        //     name: 'Facebook',
        //     href: '#',
        //     icon: '/facebook.svg',
        // },
        // {
        //     name: 'Google',
        //     href: '#',
        //     icon: '/google.svg',
        // },
    ]
}

export default function Footer() {
    return (
        <footer className="relative z-20">
            <div className="mx-auto max-w-7xl px-6 py-16 py-8 lg:px-8 lg:py-8">
                <div className="xl:grid xl:grid-cols-3 xl:gap-8">
                    <Link to="/">
                        <img
                            alt="Company name"
                            src="/logo.svg"
                            className="h-[97px]"
                        />
                    </Link>
                    <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
                        <div className="md:grid col-span-2 sm:col-span-1 sm:grid-cols-1 md:gap-8 sm:pr-20 order-2 sm:order-1">
                            <div>
                                <h3 className="text-sm/6 font-semibold text-white font-oxanium">AIAURA Core</h3>
                                <p className="text-base text-gray-400 hover:text-white font-lato">
                                    Designed for recruiters, talent teams, and agencies, AIAURA Core is your intelligent operating system for hiring. From seamless internal mobility to recruiter collaboration, AI-matching, and real-time analytics, <strong>AIAURA Core</strong> transforms recruitment into a streamlined, data-driven process—so you can consistently place the right talent, faster and with less effort.
                                </p>
                                <div className="flex gap-x-6 my-12">
                                    {navigation.social.map((item, index) => (
                                        <Link key={index} name={item.name} to={item.href} className="text-gray-400 hover:text-gray-300">
                                            <span className="sr-only">{item.name}</span>
                                            <img src={`${item.icon}`} className="h-8 w-full"/>
                                        </Link>
                                    ))}
                                </div>
                                <p className="text-base text-gray-400 hover:text-white font-lato">Copyright &copy; 2025 AIAURA Group Ltd. All Rights Reserved</p>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 col-span-2 sm:col-span-1 gap-8 order-1 sm:order-1">
                            <div>
                                <h3 className="text-sm/6 font-semibold text-white font-oxanium">About</h3>
                                <ul role="list" className="mt-6 space-y-4">
                                    {navigation.about.map((item) => (
                                        <li key={item.name}>
                                            <Link to={item.href} className="text-base text-gray-400 hover:text-white font-lato">
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="sm:mt-10 md:mt-0">
                                <h3 className="text-sm/6 font-semibold text-white font-oxanium">Support</h3>
                                <ul role="list" className="mt-6 space-y-4">
                                    {navigation.support.map((item, index) => (
                                        <li key={index} >
                                            <Link to={item.href} className="text-base text-gray-400 hover:text-white font-lato">
                                                {item.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
